import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { UpdateDivider2ModelPonBox, UpdateDividerModelPonBox, UpdateNumberPonBox, UpdatePonBox, UpdatePonBoxComing, UpdatePonBoxName } from '../../../UpdateData/UpdateCommunications';
import DialogPonBoxConnectionComponent from '../DialogConnectionComponents/DialogPonBoxConnectionComponent';
import { loadingDividerDataComponent, loadingPonBoxComingDataComponent, loadingPonBoxDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { PON_BOX, PON_BOX_FLAG } from '../../../Constants/ConstantsOptics';
import ModalDeleteComponentSpecifically from '../../../Modal/ModalDeleteComponentSpecifically';
import { UpdatePonBoxEtherComponents, UpdatePonBoxKtvComponents, UpdatePonBoxPonComponents, UpdateStatusComponents } from '../../../UpdateData/UpdateStatusComponent';
import Select from 'react-select';
import DialogPonBoxFotoEditing from '../DialogFoto/DialogPonBoxFotoEditing';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '280px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
    
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '280px'
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const PonBoxCantonEditingDialog = ({ open, onClose, onClose2, content, user, cantonRefresh, groupedCoordinatesWithColorTypeAndWidth,
  wellData,fobLocationData,couplingLocationData,ponBoxLocationData,pillarData, setIsComponentСhangeCoorPonBox}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [statusChange, setStatusChange] = useState(false);
  const [openModalConnection, setOpenModalConnection] = useState(false);
  const [ponBoxData, setPonBoxData] = useState([]);
  const [ponBoxComingData, setPonBoxComingData] = useState([]);
  const [ponBoxId, setPonBoxId] = useState("");
  const [ponBoxComingId, setPonBoxComingId] = useState("");
  const [openModalConnectionDelete, setOpenModalConnectionDelete] = useState(false);
  const [statusPon, setStatusPon] = useState(false); 
  const [statusKtv, setStatusKtv] = useState(false); 
  const [statusEther, setStatusEther] = useState(false); 
  const [dividerData, setDividerData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [dividerId, setDividerId] = useState("");

  const [showSecondDivider, setShowSecondDivider] = useState(content.divider2Id !== 5);
  const [inputValue2, setInputValue2] = useState("");
  const [divider2Id, setDivider2Id] = useState("");

  const [textNumberBox, setTextNumberBox] = useState(content.numberBox);
  const [statusChangeNumberBox, setStatusChangeNumberBox] = useState(false);

  const [openModalFoto, setOpenModalFoto] = useState(false);

  const handleСhangeCoor= (event) => {
    handleCloseDialogs();
    setIsComponentСhangeCoorPonBox(true);
  }

  const openModalConnectionComponentsDelete = () => {
    setOpenModalConnectionDelete(true);
  }; 

   useEffect(() => {
        setStatusPon(content.pon === 1);
        setStatusKtv(content.ktv === 1);
        setStatusEther(content.ether === 1);
  }, [content.activity, content.pon, content.ktv, content.ether]);
    

   //загрузка Фоб
   useEffect(() => {
    const fetchPonBoxData = async () => {
      try {
        const [data, coming, divider] = await Promise.all([
          loadingPonBoxDataComponent(),
          loadingPonBoxComingDataComponent(),
          loadingDividerDataComponent()
        ]);
        setDividerData(divider);
        setPonBoxData(data);
        setPonBoxComingData(coming);
      } catch (error) {
        console.error("Error in fetchPonBoxData:", error);
      }
    };
  
    fetchPonBoxData();
  }, []);

   const deletePonBox = () => {
          UpdateStatusComponents(PON_BOX, content.id, showSnackbar, user, cantonRefresh, handleCloseDialogs );
   }; 

  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

  const openModalConnectionComponents = () => {
    setOpenModalConnection(true);
  }; 

  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };
 
  const updatePonBox = () => {
    if (statusChange) {
      UpdatePonBox(content.id, textComment, showSnackbar,content.authorId, cantonRefresh);
    } else {
      showSnackbar('Сохранение не требуется, текст без изменений!', 'snackbarOk');
    }
  };

  const handleChangePonBoxSelect = (event) => {
    const selectedPonBox = event.target.value;
    if (selectedPonBox === "") {
      setPonBoxId("");
    } else {
      const selectedPonBox2 = ponBoxData.find(ponBox => 
        `${ponBox.id}` === selectedPonBox
      );
      if (selectedPonBox2) {
        setPonBoxId(selectedPonBox2.id);
      }
    }
  };

  const handleChangePonBoxComingSelect = (event) => {
    const selectedPonBoxComing = event.target.value;
    if (selectedPonBoxComing === "") {
      setPonBoxComingId("");
    } else {
      const selectedPonBoxComing2 = ponBoxComingData.find(ponBox => 
        `${ponBox.id}` === selectedPonBoxComing
      );
      if (selectedPonBoxComing2) {
        setPonBoxComingId(selectedPonBoxComing2.id);
      }
    }
  };

  const updatePonBoxName = () => {
  
    if (ponBoxId === "") {
      showSnackbar('Сохранение не требуется, пон-бокс без изменений!', 'snackbarOk');
    } else {
      UpdatePonBoxName(content.id, ponBoxId, showSnackbar,content.authorId, cantonRefresh );
    } 
  };

  const updatePonBoxComing = () => {
  
    if (ponBoxComingId === "") {
      showSnackbar('Сохранение не требуется, приход без изменений!', 'snackbarOk');
    } else {
      UpdatePonBoxComing(content.id, ponBoxComingId, showSnackbar,content.authorId, cantonRefresh );
    } 
  };

    const handlePonCheckboxChange = () => {
        setStatusPon(!statusPon);   
        if(!statusPon){
          UpdatePonBoxPonComponents(content.id, 1, showSnackbar, cantonRefresh, content.authorId);
        }else{
          UpdatePonBoxPonComponents(content.id, 0, showSnackbar, cantonRefresh, content.authorId)
        }
        
      };
    
      const handleKtvCheckboxChange = () => {
        setStatusKtv(!statusKtv);   
        if(!statusKtv){
          UpdatePonBoxKtvComponents(content.id, 1, showSnackbar, cantonRefresh, content.authorId);
        }else{
          UpdatePonBoxKtvComponents(content.id, 0, showSnackbar, cantonRefresh, content.authorId)
        } 
      };
    
      const handleEtherCheckboxChange = () => {
        setStatusEther(!statusEther);   
        if(!statusEther){
          UpdatePonBoxEtherComponents(content.id, 1, showSnackbar, cantonRefresh, content.authorId);
        }else{
          UpdatePonBoxEtherComponents(content.id, 0, showSnackbar, cantonRefresh, content.authorId)
        }
      };

      const options = dividerData.map(divider => ({
        value: divider.id,  
        label: divider.model,
        group: divider.polishingId === 1 ? "UPC" : "APC", 
      }));
    
      // Группировка опций
      const groupedOptions = [
        {
          label: "UPC",
          options: options.filter(option => option.group === "UPC"),
        },
        {
          label: "APC",
          options: options.filter(option => option.group === "APC"),
        },
      ];

      const handleChangeDividerSelect = (selectedOption) => {
        if (!selectedOption) {
          setDividerId(""); 
          return;
        }  
      
        const selectedDivider = selectedOption.value; // `react-select` передает объект { value, label }
        
        const selectedDividerData = dividerData.find(divider => `${divider.id}` === `${selectedDivider}`);
        
        if (selectedDividerData) {
          setDividerId(selectedDividerData.id);
        }
      };

      const handleChangeDivider2Select = (selectedOption) => {
        if (!selectedOption) {
          setDivider2Id(""); 
          return;
        }  
      
        const selectedDivider = selectedOption.value; // `react-select` передает объект { value, label }
        
        const selectedDividerData = dividerData.find(divider => `${divider.id}` === `${selectedDivider}`);
        
        if (selectedDividerData) {
          setDivider2Id(selectedDividerData.id);
        }
      };

       const updateModel = () => {
        
          if (dividerId === "") {
            showSnackbar('Нет нужды в записи, делитель без изменений!', 'snackbarOk');
          } else {
            UpdateDividerModelPonBox(content.id, dividerId, content.authorId, showSnackbar, cantonRefresh );
          } 
        };

        const updateModel2 = () => {
        
          if (divider2Id === "") {
            showSnackbar('Сохранение не требуется, делитель2 без изменений!', 'snackbarOk');
          } else {
            UpdateDivider2ModelPonBox(content.id, divider2Id, content.authorId, showSnackbar, cantonRefresh );
          } 
        };


        const handleCheckboxChange = () => {
          setShowSecondDivider(prev => !prev);
        };

        const handleNumberBoxChange = (event) => {
          const newText = event.target.value;
          setTextNumberBox(newText.trim() === "" ? null : newText);
        
          if (newText !== content.numberBox) {
            setStatusChangeNumberBox(true);
          } else {
            setStatusChangeNumberBox(false);
          }
        };

        const updateNumberBox = () => {
          if (statusChangeNumberBox) {
            UpdateNumberPonBox(content.id, textNumberBox, showSnackbar,content.authorId, cantonRefresh );
          } else {
            showSnackbar('Сохранение не требуется, номер без изменений!', 'snackbarOk');
          }
        };

         const openModalFotoFile = () => {
          setOpenModalFoto(true);
         }; 

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
           <img src='./ponbox.png' width='30' height='30' style={{ marginRight: "5px" }} />
          
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #131313ff'}}>Редактирование Пон-бокс</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Город: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.city}</span> </label>
      <br/>
              <label style={{ color: '#292929', fontWeight: 'bold' }}>
                Территория:{' '}
                <span
                  style={{
                    color: !content.canton ? '#de858e' : '#bebebe',
                    fontWeight: 'normal',
                    textShadow: '2px 2px 4px #000000ff',
                  }}
                >
                  {content.canton
                    ? content.region && content.area
                      ? `${content.canton} ${content.region} ${content.area}`
                      : content.canton
                    : 'нет'}
                </span>
              </label>  
              <hr className='horizontalLineDialog'/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Пон-бокс: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangePonBoxSelect(event);
        }} >
        <option value="">{content.fobName}</option>
        {ponBoxData.map(ponBox => (
          <option key={ponBox.id} value={ponBox.id}>{ponBox.name}</option>
        ))}
      </select>
      <button onClick={updatePonBoxName} class='buttonIsSaveDialog2'>Сохранить</button>


      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Тип прихода: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangePonBoxComingSelect(event);
        }} >
        <option value="">{content.comingType}</option>
        {ponBoxComingData.map(ponBox => (
          <option key={ponBox.id} value={ponBox.id}>{ponBox.type}</option>
        ))}
      </select>
      <button onClick={updatePonBoxComing} class='buttonIsSaveDialog2'>Сохранить</button>
      <br/>
      {/* <label style={{ color: '#292929', fontWeight: 'bold'}}>Вышестоящий узел: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{content.rankComponentName}</span> </label> */}
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Признак:</label>

        <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>PON:</label>
            <input
              type="checkbox"
              checked={statusPon}
              onChange={handlePonCheckboxChange}
              style={{ marginLeft: '10px' }}
            />      

          <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>KTV:</label>
            <input
              type="checkbox"
              checked={statusKtv}
              onChange={handleKtvCheckboxChange}
              style={{ marginLeft: '10px' }}
            />      

          <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>Ethernet:</label>
            <input
              type="checkbox"
              checked={statusEther}
              onChange={handleEtherCheckboxChange}
              style={{ marginLeft: '10px' }}
            />      
         <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

         <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <label style={{ color: "#292929", fontWeight: "bold" }}>Делитель:</label>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <input type="checkbox" checked={showSecondDivider} onChange={handleCheckboxChange} />
              <span style={{ color: "#292929", fontWeight: "bold" }}>+1</span>
            </div>
          </div>

             <Select
               className="selectSearchDrawer"
               options={groupedOptions}
               inputValue={inputValue}
               styles={customStyles}
               onInputChange={value => setInputValue(value)} 
               onChange={handleChangeDividerSelect}
               placeholder={content.dividerModel || "Выберите делитель"}
               isClearable
             />
        <button onClick={updateModel} class='buttonIsSaveDialog2' style={{fontSize: '14px', paddingTop: '3px', paddingBottom: '3px'}}>Сохранить</button> 

       {showSecondDivider && (
            <>
              <Select
                className="selectSearchDrawer"
                options={groupedOptions}
                inputValue={inputValue2}
                styles={customStyles}
                onInputChange={value => setInputValue2(value)}
                onChange={handleChangeDivider2Select}
                placeholder={content.dividerModel2 || "Выберите делитель2"}
                isClearable
              />
              <button onClick={updateModel2} className="buttonIsSaveDialog2" style={{ fontSize: '14px', paddingTop: '3px', paddingBottom: '3px' }}>
                Сохранить
              </button>
            </>
            )}
        <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #3d3d3d'}}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <label style={{ color: '#292929', fontWeight: 'bold' }}>Номер бокса: </label>

      <input
        className='textInputEditingModal'
        style={{width: '100px'}}
         value={textNumberBox} 
         onChange={handleNumberBoxChange} 
      />
      <button onClick={updateNumberBox} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "1px"}}/> 


      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />

      <br/>
      <button onClick={updatePonBox} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>

      <hr className='horizontalLineDialog'/>
      {content.nodeStatus != 1 && (
        <>
         <button  class='buttonIsCoupFobDialog' onClick={openModalConnectionComponents}> Закрепить пон-бокс</button>
         <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
         <button  class='buttonIsEditDialog' onClick={handleСhangeCoor}> Редактировать на карте</button>
         <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
         <button class='buttonIsEditDialog' onClick={openModalConnectionComponentsDelete}>Удаление связей</button>
         <hr style={{ marginBottom: "0px", opacity: 0, border: 'none', backgroundColor: 'transparent' }} />
         <button  class='buttonIsEditDialog' onClick={openModalFotoFile}> Редактирование файлов</button>
        </>
      )}  
      <hr className='horizontalLineDialog'/>

      <button 
          className="buttonIsDeleteModal" 
          onClick={deletePonBox} 
          style={{ fontSize: "14px", width: "60px", padding: "2px",textShadow: '2px 2px 4px #3d3d3d' }}
        >
          Удалить
        </button>

        <span 
          style={{
            marginLeft: "5px",
            fontSize: "12px",
            color: "#bebebe",
            textShadow: "0 0 5px rgba(0, 0, 0, 0.8)",  
          }}
        >
        Восстановление доступно в течение 24 часов
      </span>
    
      <hr className='horizontalLineDialog'/>
     

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>

        <ModalDeleteComponentSpecifically
          open={openModalConnectionDelete}
          onClose={() => setOpenModalConnectionDelete(false)}
          id={content.id}
          type={PON_BOX}
          flag={PON_BOX_FLAG}
          groupedCoordinatesWithColorTypeAndWidth={groupedCoordinatesWithColorTypeAndWidth}
          wellData={wellData}
          fobLocationData={fobLocationData}
          couplingLocationData={couplingLocationData}
          ponBoxLocationData={ponBoxLocationData}
          pillarData={pillarData}
        />

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

      <DialogPonBoxConnectionComponent
          id={content.id}
          open={openModalConnection}
          onClose={() => setOpenModalConnection(false)}
          user={user}
      />

       {/* Modal Foto*/}
       <DialogPonBoxFotoEditing
          open={openModalFoto}
          onClose={() => setOpenModalFoto(false)}
          id={content.id}
          user={content.authorId}     
      />   
    </Dialog>
  );
}

export default PonBoxCantonEditingDialog;